import { SystemsState } from 'features/systems';

export type CustomSystemRefreshState = Pick<
  SystemsState,
  | 'activeCustomSystemSavesByConfig'
  | 'customSystemsRevisionByConfig'
  | 'settledCustomSystemsRevisionByConfig'
>;

export function isCustomSystemRefreshPending(
  systems: CustomSystemRefreshState,
  configId: string
): boolean {
  const activeSaves = systems.activeCustomSystemSavesByConfig[configId] ?? 0;
  const revision = systems.customSystemsRevisionByConfig[configId] ?? 0;
  const settled = systems.settledCustomSystemsRevisionByConfig[configId] ?? 0;
  return activeSaves > 0 || revision > settled;
}
